(function () {
  const SCROLL_THRESHOLD = 64;
  let scrolled = false;

  function updateScrollState() {
    const isScrolled = window.scrollY > SCROLL_THRESHOLD;
    if (isScrolled !== scrolled) {
      scrolled = isScrolled;
      document.body.dataset.scrolled = String(isScrolled);
    }
  }

  // Throttle via rAF
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateScrollState();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateScrollState();

  function injectTagline() {
    const logo = document.querySelector('.header-logo');
    if (!logo || logo.querySelector('.header-logo__tagline')) return;
    if (window.innerWidth < 990) return;

    const separator = document.createElement('span');
    separator.className = 'header-logo__separator';
    separator.setAttribute('aria-hidden', 'true');

    const tagline = document.createElement('span');
    tagline.className = 'header-logo__tagline';
    tagline.textContent = "L'étanchéité pro pour les particuliers";

    logo.appendChild(separator);
    logo.appendChild(tagline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTagline);
  } else {
    injectTagline();
  }

  // Re-inject if logo re-renders (e.g., theme editor)
  const observer = new MutationObserver(() => {
    injectTagline();
    enhanceDrawer();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const ICON_MAP = {
    'toiture': 'roof',
    'terrasse': 'roof',
    'bassin': 'drop',
    'coupe': 'ruler',
    'aide': 'support',
    'tuto': 'support',
  };

  const NS = 'http://www.w3.org/2000/svg';
  const ICON_SVG = {
    roof: `<svg xmlns="${NS}" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 18L16 7l12 11"/><path d="M7 17v9h18v-9"/><path d="M14 26v-6h4v6"/></svg>`,
    drop: `<svg xmlns="${NS}" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4c-4 5-8 9-8 14a8 8 0 0 0 16 0c0-5-4-9-8-14z"/><path d="M12 18a4 4 0 0 0 4 4"/></svg>`,
    ruler: `<svg xmlns="${NS}" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 11l16 16-6 6L4 17l1-6z" transform="rotate(-45 16 16)"/></svg>`,
    support: `<svg xmlns="${NS}" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 18a11 11 0 1 1 22 0v6"/><path d="M5 18v4a3 3 0 0 0 3 3h2v-9H8a3 3 0 0 0-3 2z"/><path d="M27 18v4a3 3 0 0 1-3 3h-2v-9h2a3 3 0 0 1 3 2z"/></svg>`,
  };

  // Parse SVG string safely (without using innerHTML on the live DOM)
  function svgFromString(str) {
    const parser = new DOMParser();
    // Wrap in HTML doc so the SVG renders correctly with proper namespace
    const doc = parser.parseFromString(str, 'image/svg+xml');
    const svg = doc.documentElement;
    // Adopt into current document to ensure proper rendering
    return document.importNode(svg, true);
  }

  function getIconFor(text) {
    const lower = text.toLowerCase();
    for (const key in ICON_MAP) {
      if (lower.includes(key)) return ICON_MAP[key];
    }
    return null;
  }

  function enhanceDrawer() {
    // Inject icons before each top-level menu item text
    document.querySelectorAll('.menu-drawer__menu-item--mainlist').forEach((item) => {
      if (item.querySelector('.menu-drawer__icon-wrapper')) return;
      const textEl = item.querySelector('.menu-drawer__menu-item-text');
      if (!textEl) return;
      const iconKey = getIconFor(textEl.textContent);
      if (!iconKey || !ICON_SVG[iconKey]) return;

      const iconWrap = document.createElement('span');
      iconWrap.className = 'menu-drawer__icon-wrapper';
      iconWrap.setAttribute('aria-hidden', 'true');
      iconWrap.appendChild(svgFromString(ICON_SVG[iconKey]));

      item.insertBefore(iconWrap, item.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDrawer);
  } else {
    enhanceDrawer();
  }
})();
